class InteractiveOrigin {
    constructor(data) {
        this.left = data.left;
        this.top = data.top;
    }
}

export default InteractiveOrigin;